import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { SystemSliceState } from '@/features/system/store/types';
import type { TenantConfiguration } from '@/features/system/store/types/TenantConfiguration';

const initialState: SystemSliceState = {
  isTenantConfigurationLoading: false,
  isLoading: false,
  navigate: null,
  tenantConfiguration: null,
};

const systemSlice = createSlice({
  name: 'systemSlice',
  initialState,
  reducers: {
    setSystemLoadingStatus: (state, { payload }: PayloadAction<boolean>) => {
      state.isLoading = payload;
    },
    getTenantConfiguration: (state) => {
      state.isLoading = true;
      state.isTenantConfigurationLoading = true;
    },
    getTenantConfigurationSuccess: (state, { payload }: PayloadAction<TenantConfiguration | null>) => {
      state.isLoading = false;
      state.isTenantConfigurationLoading = false;
      state.tenantConfiguration = payload;
    },
    processQueueOfActions: (_state, _action: PayloadAction<PayloadAction<any>[]>) => {},
  },
});

export const { getTenantConfiguration, getTenantConfigurationSuccess, setSystemLoadingStatus, processQueueOfActions } =
  systemSlice.actions;

export const systemSliceReducerPath = systemSlice.reducerPath;

export const systemSliceReducer = systemSlice.reducer;
